import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FeatureFlagsFacade, SignalRFacade } from '@ra-state';
import { map } from 'rxjs';

@Component({
  selector: 'app-signalr-status',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './signalr-status.component.html',
  styleUrl: './signalr-status.component.scss',
})
export class SignalrStatusComponent {
  private readonly signalRFacade = inject(SignalRFacade);
  private readonly featureFlags = inject(FeatureFlagsFacade);

  hubConnectionState$ = this.signalRFacade.connectionState$;
  enabled$ = this.featureFlags.getFlagValue$('ui_suppress_signalr_pinger').pipe(map((v: boolean) => !v));
}
